// DS: B16
import React from 'react';
import classnames from 'classnames';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/Check';
import { useWatchButton } from '../../WatchButton/useWatchButton';
import s from './UserWatchGhostButton.scss';
export const UserWatchGhostButton = ({ author, className, children, onWatch, iconClassName, isWatchingBack, watchingClassname, onToggleWatchSuccess })=>{
    const { onClick, text, isWatching, biData } = useWatchButton(author, author === null || author === void 0 ? void 0 : author.isWatching, isWatchingBack, false, onToggleWatchSuccess);
    return /*#__PURE__*/ React.createElement(GhostButton, {
        size: "small",
        variant: "approval-green",
        className: classnames(s['root'], isWatching && s['watching'], isWatching && watchingClassname, className),
        biData: biData,
        onClick: ()=>{
            onClick();
            if (!isWatching) {
                onWatch && onWatch();
            }
        }
    }, /*#__PURE__*/ React.createElement(Plus, {
        customSizable: true,
        className: classnames(s['plus-icon'], iconClassName),
        size: IconSize.SMALL
    }), isWatching && /*#__PURE__*/ React.createElement(Check, {
        customSizable: true,
        className: classnames(s['check-icon'], iconClassName),
        size: IconSize.SMALL
    }), children || text);
};
UserWatchGhostButton.displayName = 'UserWatchGhostButton';
export default UserWatchGhostButton;
